/* List of addons */
import React from 'react';

import currencyFormatter from 'currency-formatter';
import { connect } from 'react-redux';

import { TableCell, TableRow } from '@mui/material';

import getPackagePriceByCurrency from '~/utils/getPackagePriceByCurrency';

type AddonPrice = {
  currency_code: string;
  price: number;
};

type AddonDisplay = App.Addon & {
  id?: string;
  itemId?: string;
  offerPackageId?: string;
  prices: Array<AddonPrice>;
  purchase_limit?: number;
};

type AddonAction = (addon: AddonDisplay, item?: App.CartItem, offer?: App.CartOffer) => void;

interface OwnProps {
  item?: App.CartItem;
  addon: AddonDisplay;
  getAddonQuantity: (addon: AddonDisplay) => number;
  onRemoveAddon?: (addon: AddonDisplay) => void;
  onAddAddon?: AddonAction;
  offer: App.CartOffer;
}

interface StateProps {
  currencyCode: string;
}

type AddonItemProps = OwnProps & StateProps;

const AddonItem = (props: AddonItemProps) => {
  const { item, addon, getAddonQuantity, onRemoveAddon, onAddAddon, currencyCode, offer } = props;

  const addonQuantity = getAddonQuantity(addon);
  const isAddDisabled = addon.purchase_limit && addonQuantity >= addon.purchase_limit;
  const isRemoveDisabled = addonQuantity <= 0;
  return (
    <TableRow className="booking-form" data-no-dark-override data-testid={addon.id_salesforce_external}>
      <TableCell width="70%">
        <p>
          <strong>{addon.name}</strong>
        </p>
        <span>{addon.description}</span>
      </TableCell>
      <TableCell>{addon.channel_fare_type || `-`}</TableCell>
      <TableCell>
        {currencyCode}
        <span>
          {currencyFormatter.format(getPackagePriceByCurrency(addon, currencyCode).price, { code: currencyCode })}
        </span>
      </TableCell>
      <TableCell className="quanity-btn-cell">
        <input type="number" className="quantity-value" value={addonQuantity} disabled />
        {!addon.complimentary && (
          <>
            <button className="quantity-btn" disabled={isRemoveDisabled} onClick={() => onRemoveAddon!(addon)}>
              &mdash;
            </button>
            <button className="quantity-btn" disabled={isAddDisabled} onClick={() => onAddAddon!(addon, item, offer)}>
              +
            </button>
          </>
        )}
      </TableCell>
    </TableRow>
  );
};

const mapStateToProps = (state: App.State): StateProps => {
  return {
    currencyCode: state.cart.currencyCode || 'AUD',
  };
};

export default connect(mapStateToProps)(AddonItem);
